import request from '@/service/index'
import postJsonRequest from "@/service/postJson"
/**
 * 获取分类
 */
export const getCategory = (params) => {
    return request({
        url: 'base/category/selectCategoryForTree',
        params,
        method: 'get'
    })
}

export function getDictList(codeTypeList) {
    const data = {codeTypeList: codeTypeList}
    return postJsonRequest({
        url: 'base/code/qryBaseCodeByCodeTypes',
        data,
        method: 'post'
    })
}

//获取地区信息列表
export function getArea(params) {
    return request({
        url: 'base/area',
        params,
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/base.js